var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane py-2 py-xl-4 fade",class:_vm.isActive,attrs:{"id":`${_vm.id}`,"role":"tabpanel","aria-labelledby":`${_vm.id}-tab`}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }